import React, { Component } from "react";
import { Button, Modal, Form, Grid, Label, Input, Message } from "semantic-ui-react";
import request from "../../../utils/request";

class FreeTicket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customer: {
        first_name : "",
        last_name : "",
        email : "",
        phone : ""
      },
      emailError: false
    }
  }

  // handle post request for free ticket
  handleSubmit = () => {
    const { gameId, envelope, eventId, fetchPayments, onError, onClose } = this.props;
    const { email } = this.state.customer;
    let payload = {
      customer: this.state.customer
    };

    const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
    if (!emailRegex.test(email)) {
      this.setState({ emailError: true });
      return; // return early if the email is not valid
    } else {
      this.setState({ emailError: false });
    }

    if (gameId === 3) {
      if (envelope === 0) {
        onError("Please select an envelope number for the Free Ticket.");
        return; // return early to avoid making the request
      } else {
        payload.envelope = envelope;
      }
    }

    // make sure the selected envelope hasn't already been drawn
    return request.post(this, `api:/event/${eventId}/free-tickets`, payload).then(resp => {
      if(resp.exception || resp.status === "error") {
        onError(resp.message);
      } else {
        // reset customer state
        this.setState({
          customer: {
            first_name : "",
            last_name : "",
            email : "",
            phone : ""
          },
          emailError: false
        });
        fetchPayments();
        onClose();
      }
    });
  };

  handleChange = (e, { name, value }) => {
    this.setState(prevState => ({
      customer: {
        ...prevState.customer,
        [name]: value
      }
    }));
  }

  handleCancel = () => {
    const { onClose } = this.props;
    this.setState({ emailError: false });
    onClose();
  }

  render() {
    const { modal, invalidEnvelope, freeTicketEnabled, gameId, freeTicketMessage, envelope, onChange } = this.props;
    const { first_name, last_name, email } = this.state.customer;
    const { emailError } = this.state;

    const isCTA = gameId === 3;
    const isConfirmDisabled = isCTA ? invalidEnvelope || !freeTicketEnabled : !freeTicketEnabled;

    return (
      <Modal
        open={modal.isOpen}
        closeIcon
        onClose={this.handleCancel}
      >
        <Modal.Header content={modal.content} />
        <Modal.Content>
          {freeTicketMessage !== "" && <Message>{freeTicketMessage}</Message>}
          <Grid>
            <Grid.Row columns={4}>
              <Grid.Column>
                <Form.Field error={emailError}>
                  <label>Email <span style={{ color: 'red' }}>*</span></label>
                  <Input
                    type="email"
                    name="email"
                    onChange={this.handleChange}
                    value={email}
                  />
                  {emailError && <Label basic color='red' pointing>Please enter a valid email</Label>}
                </Form.Field>
              </Grid.Column>
              <Grid.Column>
                <Form.Input
                  label="First Name"
                  type="text"
                  name="first_name"
                  onChange={this.handleChange}
                  value={first_name}
                />
              </Grid.Column>
              <Grid.Column>
                <Form.Input
                  label="Last Name"
                  type="text"
                  name="last_name"
                  onChange={this.handleChange}
                  value={last_name}
                />
              </Grid.Column>
              {isCTA && (
                <Grid.Column>
                  <Form.Input
                    label="Envelope #"
                    type="number"
                    name="envelope"
                    onChange={onChange}
                    value={envelope}
                  />
                </Grid.Column>
              )}
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={this.handleCancel}>
            Cancel
          </Button>
          <Button
            positive
            onClick={this.handleSubmit}
            disabled={isConfirmDisabled}
          >
            Confirm
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default FreeTicket;
